import { Filter, FileSpreadsheet } from 'lucide-react';
import { Input, Select } from '@/components/ui';
import type { StockMovementFilters } from '../types/stockMovements.types';

interface StockMovementsToolbarProps {
  filters: StockMovementFilters;
  onSearchChange: (val: string) => void;
  onTypeChange: (val: string) => void;
  onDateRangeChange: (from: string, to: string) => void;
}

export function StockMovementsToolbar({ filters, onSearchChange, onTypeChange, onDateRangeChange }: StockMovementsToolbarProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-slate-800">Lịch sử giao dịch</h3>
        <button
          type="button"
          className="bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 h-9 px-4 rounded-md inline-flex items-center gap-2 sm:text-sm text-xs transition-colors"
        >
          <FileSpreadsheet className="w-4 h-4 text-emerald-600" />
          <span className="hidden sm:inline">Xuất báo cáo</span>
        </button>
      </div>

      <div className="flex flex-wrap items-center gap-3 bg-white p-3 border border-slate-200 rounded-md">
        <div className="relative flex-1 min-w-[200px] max-w-sm">
          <Filter className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input
            value={filters.search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Tìm mã vật tư, tên, ghi chú..."
            className="pl-9 h-9 sm:text-sm text-xs"
          />
        </div>
        
        <div className="w-40 shrink-0">
          <Select
            value={filters.transaction_type}
            onChange={(e) => onTypeChange(e.target.value)}
            className="h-9 sm:text-sm text-xs"
          >
            <option value="all">Tất cả giao dịch</option>
            <option value="stock_in">Nhập kho</option>
            <option value="stock_out">Xuất kho</option>
            <option value="adjustment">Điều chỉnh</option>
            <option value="transfer">Luân chuyển</option>
          </Select>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <Input
            type="date"
            value={filters.date_from}
            onChange={(e) => onDateRangeChange(e.target.value, filters.date_to)}
            className="h-9 w-36 sm:text-sm text-xs"
          />
          <span className="text-slate-400">-</span>
          <Input
            type="date"
            value={filters.date_to}
            onChange={(e) => onDateRangeChange(filters.date_from, e.target.value)}
            className="h-9 w-36 sm:text-sm text-xs"
          />
        </div>
      </div>
    </div>
  );
}
